import React from 'react';
import '../styles/BookCard.css';
import { motion } from 'framer-motion';
import { FaStar, FaStarHalfAlt, FaRegStar } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

export default function BookCard({ id, title, image, price, offer, rating = 4.5, reviews = 1200 }) {
  const navigate = useNavigate();
  const discount = Math.round(((price - offer) / price) * 100);

  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  // const handleClick = () => {
  //   // Navigate to /book/Atomic-Habits with id in state
  //   const formattedTitle = title.toLowerCase().replace(/\s+/g, '-');
  //   navigate(`/books/${formattedTitle}`, { state: { bookId: id } });
  // };

  const handleClick = () => {
    navigate(`/books?bookId=${id}`);
  };
  

  return (
    <motion.div
      className="book-card"
      onClick={handleClick}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <img src={image} alt={title} className="book-image" />
      <div className='book-details'>
      <h3 className="book-title">{title}</h3>

<div className="book-rating">
  {[...Array(fullStars)].map((_, i) => <FaStar key={`full-${i}`} className="star-icon" />)}
  {hasHalfStar && <FaStarHalfAlt className="star-icon" />}
  {[...Array(emptyStars)].map((_, i) => <FaRegStar key={`empty-${i}`} className="star-icon" />)}
  <span className="reviews-count">({reviews})</span>
</div>

<div className="book-price">
  <span className="original-price">₹{price}</span>
  <span className="offer-price">₹{offer}</span>
  <span className="discount">{discount}% off</span>
</div>
      </div>
    </motion.div>
  );
}
